import React, { lazy, Suspense, useEffect, useState } from 'react';

import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import RegularButton from '../../components/CustomButtons/Button';
import { createRetailerFTPCredentials, updateRetailerFTPConfig, getSellersForConfig} from "../../api";
//import SellerForm from './SellerForm';
import { useSelector } from "react-redux";

import Table from "../../components/Table/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableHead from "@material-ui/core/TableHead";
// import TableRow from "@material-ui/core/TableRow";
import _ from "lodash";
import moment from "moment";
import classNames from "classnames";

import Overlay from "../../components/Overlay/Overlay";
import { BsThreeDots } from "react-icons/all";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import { connect } from "react-redux";
import SellerFTPDialog from "./SellerFTPDialog"
import SellerAPIDialog from "./SellerAPIDialog"

import { SmallUppercase } from "../../text";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import CustomInput from "../../components/CustomInput/CustomInput";
import Check from "@material-ui/icons/Check";

import {
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

const useStyles = makeStyles(styles);
function OpenContext({ currentUser, seller, updateRow, openFTPDialog }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [warning, setWarning] = React.useState(null);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickMenuItem = (e, fxn) => {
    e.stopPropagation();
    e.preventDefault();

    switch (fxn) {
      case "create_credentials":
          if(currentUser.type !== "saucey_admin"){
            setWarning({type:"invalid_permissions", cb:() => {}, noCancel:true })
          }else{
            setLoading(true);
            createRetailerFTPCredentials(seller.store_id).then( (result) => {
              if(result && result.data){
                seller.hasCredentials = true;
                updateRow(result.data, () => {
                  setLoading(false);
                  handleClose()
                });
              }
              
            }).catch( () => {
              setLoading(false);
            })
          }
        break;
      case "get_credentials":
        console.log('open dialog:', seller.store_id);
        openFTPDialog(true, seller);
        break;
      default:
    }
  };

  const warningDialog = () => {
    let content;
    let title = "Are you sure?";
    // switch (warning.type) {
    //   case "how_to_reenable":
    //     title = null;
    //     content = `Assign at least one permission to ${account.first_name} ${account.last_name} to re-enable their account`;
    //     break;
    //   case "invitation_resent":
    //     title = null;
    //     content = `Email has been re-sent to ${account.first_name} ${account.last_name}`;
    //     break;
    //   case "disable":
    //     content = `Are you sure you want to disable ${account.first_name} ${account.last_name}'s account?`;
    //     break;
    //   case "demote":
    //     content = `Are you sure you want to change ${account.first_name} ${account.last_name}'s account to a regular user account?`;
    //     break;
    //   case "promote":
    //     content = `Are you sure you want to change ${account.first_name} ${account.last_name}'s account to global admin account?  All fine-grain permissions for this user will be removed.`;
    //     break;
    // }
    return (
      <Dialog open={true} maxWidth="md" fullWidth>
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {!warning.noCancel && <RegularButton
            color="info"
            onClick={() => {
              setWarning(null);
            }}
          >
            Cancel
          </RegularButton>}
          <RegularButton
            color="primary"
            onClick={() => {
              setWarning(null);
              warning.cb();
            }}
          >
            Continue
          </RegularButton>
        </DialogActions>
      </Dialog>
    );
  };
  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover);
  return (
    <div>
      {warning && warningDialog()}
      <RegularButton
        disableRipple
        justIcon
        aria-controls="simple-menu"
        color="transparent"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <BsThreeDots />
      </RegularButton>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        transition
        disablePortal
        placement="bottom"
        className={classNames({
          [classes.popperClose]: !anchorEl,
          [classes.popperResponsive]: true,
          [classes.popperNav]: true,
        })}
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            id="profile-menu-list"
            style={{ transformOrigin: "0 0 0" }}
          >
            <Paper className={classes.dropdown}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList role="menu">
                  <MenuItem
                    onClick={(e) => handleClickMenuItem(e, seller.hasCredentials ? "get_credentials" : "create_credentials")}
                    className={dropdownItem}
                  >
                    {seller.hasCredentials ? "Edit FTP Credentials" : "Create FTP Credentials"} 
                  </MenuItem>                
                </MenuList>
              </ClickAwayListener>
              {loading && (
                <Overlay
                  type={"loading"}
                  rootClasses={classes.overlayRoot}
                  containerClasses={classes.overlayContainer}
                />
              )}
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}

class SellerConfigTable extends React.Component {
  state = {
    sellers: [],
    loading: true,
    ftpDialog: false,
    apiDialog: false,
    selectedSeller: null,
    showArchived:false,
    showEnabled:true,
    showFeed:false,
    showAPI:false
  };

  _loadStores(){
    const enabled = this.state.showEnabled, archived = this.state.showArchived, feed = this.state.showFeed, api = this.state.showAPI;
    console.log('load stores');
    this.setState({ loading: true }, () => {
      getSellersForConfig(enabled, archived, feed, api).then((results)=>{
        if(results && results.data){
          console.log(`received ${results.data.length}`)
          let sellers = results.data.map((item)=>{
            if(_.get(item, 'import_settings.credentials.host')){
              item.hasCredentials = true;
            } else {
              item.hasCredentials = false;
            }
            if(_.get(item, 'api_credentials._id')){
              item.hasApiCredentials = true;
            } else {
              item.hasApiCredentials = false;
            }
            return item;
          })
          this.setState({ sellers: sellers, loading: false });
        }
        else {
          this.setState({loading:false})
        }
      })
    });
  }
  componentDidUpdate(prevProps, prevState){
    if(prevState.showArchived != this.state.showArchived || 
      prevState.showEnabled != this.state.showEnabled ||
      prevState.showFeed != this.state.showFeed ||
      prevState.showAPI != this.state.showAPI){
      this._loadStores();
    }
  }
  componentDidMount(){
    this._loadStores();
  }
  openDialog = (open, seller) => {
    this.setState({ftpDialog:open, selectedSeller:seller})
  }
  openAPIDialog = (open, seller) => {
    this.setState({apiDialog:open, selectedSeller:seller})
  }
  allowEditConnection(hostName) {
    return (!hostName || hostName.indexOf("sftp.sauceyteam.com") !== 0);
  }
  render() {

    const { sellers, loading, ftpDialog, apiDialog, selectedSeller, showArchived, showEnabled, showFeed, showAPI} = this.state;
    const { classes } = this.props;

    let canEditConnection = false;
    if(selectedSeller){
      if(_.get(selectedSeller, 'import_settings.credentials.host') && this.allowEditConnection(selectedSeller.import_settings.credentials.host)){
        canEditConnection = true;
      }
      console.log(`selected :${selectedSeller.store_id}`)
    }
    
    return (
      <>
        {loading && <Overlay type="loading" />}
        {ftpDialog && (
          <SellerFTPDialog
            seller={selectedSeller}
            editConnection={canEditConnection}
            closeFTPDialog={(reload) => {
              this.setState({ ftpDialog: false });
            }}
          />
        )}
        {apiDialog && (
          <SellerAPIDialog
            seller={selectedSeller}
            closeAPIDialog={(reload) => {
              if(reload){
                this._loadStores();
              }
              this.setState({ apiDialog: false });
            }}
          />
        )}
        <span><Checkbox
          checked={showEnabled}
          onClick={(e) => {this.setState({showEnabled:!showEnabled})}}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        /> Show Only Enabled</span>
        <span><Checkbox
          checked={showFeed}
          onClick={(e) => {this.setState({showFeed:!showFeed})}}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        /> Show Only Feed Enabled</span>
        <span><Checkbox
          checked={showArchived}
          onClick={(e) => {this.setState({showArchived:!showArchived})}}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        /> Show Archived</span>
        <span><Checkbox
          checked={showAPI}
          onClick={(e) => {this.setState({showAPI:!showAPI})}}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        /> Show API Enabled</span>
        <Table
          striped
          tableHead={[
            "StoreID",
            "Store Name",
            "City",
            "Enabled",
            "Avatax",
            "Feed Enabled",
            "API Credentials",
            "Inventory Credentials",
          ]}
          hits={sellers}
          tableData={sellers.map((seller, idx) => {
            let status = seller.enabled ? (
              <span style={{ color: "green" }}>Active</span>
            ) : (
              <span style={{ color: "gray" }}>Disabled</span>
            );
            let avataxStat = seller.avalara_tax ? (
              <span style={{ color: "green" }}>Active</span>
            ) : (
              <span style={{ color: "gray" }}>Disabled</span>
            );
            let importSettings = <span style={{ color: "gray" }}>Disabled</span>;
            if( _.get(seller, 'import_settings.credentials.host')){
              importSettings = <span style={{color: "green"}}>Read External FTP</span>
              if(seller.import_settings.credentials.host == "sftp.sauceyteam.com"){
                importSettings = <span style={{color: "#f54c35"}}>Push to Saucey FTP</span>
              }
            } else if(seller.api_integration){
              importSettings = seller.api_integration;
            }
            let apiCredentials = <span style={
              { color: "gray", cursor: 'pointer' }} 
                onClick={() => this.openAPIDialog(true, seller)}
              >Disabled</span>;
            if(seller.hasApiCredentials){
              apiCredentials = <span 
                style={{ color: "green", cursor: 'pointer' }} 
                onClick={() => this.openAPIDialog(true, seller)}
              >
                {seller.api_credentials.provider}
              </span>
            }

            return [
              <div className="name">
                <p>{seller.store_id}</p>
              </div>,
              <div className="name">
                <p>{seller.name}</p>
              </div>,
              <div className="name">
                <p>{seller._city.name}</p>
              </div>,
              status,
              avataxStat,
              importSettings,
              apiCredentials,
              <OpenContext
                seller={seller}
                currentUser={this.props.user}
                openFTPDialog={this.openDialog}
                updateRow={(newInfo, cb) => {
                  sellers[idx] = newInfo;
                  this.setState({ sellers }, cb);
                }}
              />
              ];
          })}
        />
      </>
    );
  }
}
export default connect((state) => ({ user: state.app.user }))(
  withStyles(styles)(SellerConfigTable)
);
